import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles, Grid, Hidden, IconButton } from '@material-ui/core'
import conversationItemTypes from './conversationItemTypes'
import { read } from 'actions/data'
import AvatarWithLabel from '../AvatarWithLabel'
import contactLabel from 'utils/contactLabel'
import { withRouter } from 'react-router-dom'
import { stepperGoTo, toggleDialog } from 'actions/view'
import { Visibility } from '@material-ui/icons'
import moment from 'moment'
import DudeReadingV2Icon from 'components/theme/DudeReadingV2Icon'
import Button from 'components/theme/Button'
// import openAiAllowedAccountIDs from 'utils/openAiAllowedAccountIDs'
import { generateInboxResponse } from 'actions/InboxAI/generateInboxResponse'
import { deleteEntity } from 'actions/data'
import sectionsByID from 'utils/forms/sectionsByID'
import { DATA_API_URL } from 'utils/AllURLs'

// const devOrProd =
//   window?.location?.href?.slice?.(0, 29) === 'https://console.vastreach.com'
//     ? 'Prod'
//     : 'Dev'

const styles = theme => ({
  threadItemContainer: {
    padding: '10px 20px 10px 60px',
    position: 'relative',
  },
  threadItem: {
    backgroundColor: '#f1f1f1',
    padding: '12px 16px 16px 62px',
    borderRadius: 13,
    position: 'relative',
    minHeight: 207,
  },
  iconContainer: {
    position: 'absolute',
    top: '50%',
    left: 14,
    transform: 'translate(0, -50%)',
    textAlign: 'center',
  },
  icon: {
    fill: '#c2c2c2',
    fontSize: 30,
  },
  iconLabel: {
    fontSize: 10,
    color: '#c2c2c2',
    marginTop: '-4px',
  },
  avatar: {
    position: 'absolute',
    top: 12,
    left: 12,
  },
  viewFormButton: {
    color: '#0000008A',
    fontSize: 12,
    cursor: 'pointer',
    borderRadius: 12,
    padding: '0 6px 0 2px',
    '&:hover': {
      backgroundColor: '#0000004a',
    },
    position: 'absolute',
    bottom: 4,
    left: 57,
  },
  answeredForm: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    maxWidth: 'calc(100% - 113px)',
    textDecoration: 'underline',
    fontSize: 16,
    [theme.breakpoints.down('md')]: {
      maxWidth: 'calc(100% - 26px)',
    },
  },
})

class FormItem extends Component {
  state = { sectionsByID: null }

  componentDidMount() {
    if (!this.props.response) {
      this.props.read(
        this.props.conversationItem?.formsub?.submittal_uri?.slice?.(18),
        'customform/entry',
        null,
        null,
        'object',
        this.props.conversationItem?.formsub?.submittal_uri?.slice?.(18),
      )
    }

    if (!this.props.customform) {
      this.props.read(this.props.conversationItem?.formsub?.id, 'customform')
    }

    if (this.props.response && this.props.customform) {
      this.setSectionsByID(this.props.customform)
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.customform && this.props.customform) {
      if (this.props.response) {
        this.setSectionsByID(this.props.customform)
      }
    }

    if (!prevProps.response && this.props.response) {
      if (this.props.customform) {
        this.setSectionsByID(this.props.customform)
      }
    }
  }

  setSectionsByID = customform => {
    this.setState({ sectionsByID: sectionsByID(customform) })
  }

  render() {
    const Icon = conversationItemTypes[this.props.conversationItem.type].icon

    const answers = {
      ...(this.props.response?.contact_fields || {}),
      ...(this.props.response?.custom_fields || {}),
    }

    const toggleAndSend = () => {
      this.props.toggleDialog({
        open: true,
        dialog: 'InboxAiResponse',
        options: {
          // to: sms?.originator_number,
        },
      })

      this.props.generateInboxResponse({
        // CHANGE THIS:
        conversationItem: this.props.conversationItem,
        index: this.props.index, // <-- there might be an issue with this and filtering,
        // if the index is different when we filter by type or search
        type: 'generateFormResponse',
      })
    }

    const onClick = () => {
      if (this.props.openaiinboxresponseID) {
        this.props
          .deleteEntity(
            this.props.openaiinboxresponseID,
            'openaiinboxresponse',
            `${DATA_API_URL}/openaiinboxresponse/${this.props.openaiinboxresponseID}`,
            'none',
          )
          .then(() => toggleAndSend())
      } else {
        toggleAndSend()
      }
    }

    return (
      <div
        key={this.props.key}
        className={this.props.classes.threadItemContainer}
      >
        <div className={this.props.classes.iconContainer}>
          <Icon className={this.props.classes.icon} />
          <div className={this.props.classes.iconLabel}>
            {conversationItemTypes[this.props.conversationItem.type].label}
          </div>
        </div>
        <div className={this.props.classes.threadItem}>
          <div className={this.props.classes.avatar}>
            <AvatarWithLabel
              type={
                this.props.conversationItem.direction === 'inbound'
                  ? 'contact'
                  : 'user'
              }
              contact={this.props.contact}
              label={contactLabel(this.props.contact)}
            />
            {/* {conversationItem.type} */}
          </div>
          {this.props.response && this.props.customform && (
            <Grid
              justify="center"
              direction="column"
              container
              alignItems="flex-start"
              style={{
                fontSize: 14,
                minHeight: 52,
              }}
            >
              <div className={this.props.classes.answeredForm}>
                {`Answered form '${this.props.customform?.name}'`}
              </div>
              <div style={{ marginTop: 3, color: '#5f5f5f', fontSize: 14 }}>
                {moment(this.props.conversationItem?.timestamp).format(
                  'ddd, MMM D, YYYY h:mm A',
                )}
              </div>
              {
                // by default, all of our permissions are basically "true" by default,
                // if they're undefined, so we check for false, but we'll eventually change this
                this.props.formsPermissions !== false && (
                  <>
                    <Grid item style={{ maxWidth: '100%' }}>
                      <div
                        style={{
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                        }}
                      >
                        {Object.keys(answers)
                          ?.slice(0, 8)
                          ?.map((field_name, idx) => {
                            const section =
                              this.state.sectionsByID?.[field_name]
                            const fieldOrContactField =
                              section?.field || section?.contactfield

                            if (
                              answers?.[field_name] !== null &&
                              answers?.[field_name]?.toString?.() !== ''
                            ) {
                              return (
                                <Fragment
                                  key={`FormItemFieldMap${idx}${this.props.conversationItem?.timestamp}`}
                                >
                                  <strong>
                                    {section?.label || field_name || 'Unknown'}
                                    {fieldOrContactField?.required && (
                                      <span style={{ color: 'red' }}>*</span>
                                    )}
                                    :{' '}
                                  </strong>
                                  {Array.isArray(answers?.[field_name])
                                    ? answers?.[field_name]?.join?.(', ')
                                    : answers?.[field_name]}
                                  <br />
                                </Fragment>
                              )
                            }
                            return null
                          })}
                      </div>
                    </Grid>
                    <div
                      onClick={() =>
                        this.props.toggleDialog({
                          open: true,
                          dialog: 'individualFormResponse',
                          options: {
                            response: this.props.response,
                            sectionsByID: this.state.sectionsByID,
                          },
                        })
                      }
                      className={this.props.classes.viewFormButton}
                    >
                      <Visibility
                        style={{
                          marginRight: 2,
                          verticalAlign: 'middle',
                          marginTop: '-2px',
                        }}
                      />
                      View full form response
                    </div>
                  </>
                )
              }
            </Grid>
          )}
          {this.props.formsPermissions === false && (
            <div style={{ fontWeight: 'bold' }}>
              You don't have access to these form results.
            </div>
          )}
        </div>
        {this.props.conversationItem.direction === 'inbound' &&
          this.props.formsPermissions !== false && (
            <>
              <Hidden lgUp>
                <div style={{ position: 'absolute', top: 13, right: 23 }}>
                  <IconButton
                    style={{
                      padding: 5,
                      // backgroundColor: '#014c94',
                      // color: '#fff',
                    }}
                    onClick={() => onClick()}
                    variant="outlined"
                    color="secondary"
                  >
                    <DudeReadingV2Icon />
                  </IconButton>
                </div>
              </Hidden>
              <Hidden mdDown>
                <Button
                  onClick={() => onClick()}
                  style={{
                    position: 'absolute',
                    top: 17,
                    right: 27,
                    textTransform: 'none',
                  }}
                  variant="outlined"
                  color="secondary"
                >
                  <DudeReadingV2Icon style={{ marginRight: 7 }} />
                  VastGPT
                </Button>
              </Hidden>
            </>
          )}
      </div>
    )
  }
}

export default withRouter(
  connect(
    (state, { conversationItem }) => {
      const username =
        state.auth?.session?.idToken?.payload?.['cognito:username']
      const vr_account_id =
        state.auth?.session?.idToken?.payload?.['custom:vr_account_id']

      return {
        response:
          state.data?.['customform/entry']?.[
            conversationItem?.formsub?.submittal_uri?.slice?.(18)
          ],
        customform: state.data?.['customform']?.[conversationItem?.formsub?.id],
        vr_account_id,
        openaiinboxresponseID: Object.keys(
          state.data?.openaiinboxresponse || {},
        )?.[0],
        formsPermissions:
          state.data?.screenpermissions?.[
            `screenpermissions-${username}-${vr_account_id}`
          ]?.permissions?.forms,
      }
    },
    dispatch =>
      bindActionCreators(
        {
          read,
          stepperGoTo,
          toggleDialog,
          generateInboxResponse,
          deleteEntity,
        },
        dispatch,
      ),
  )(withStyles(styles)(FormItem)),
)
